import { getAuthHeader } from "./authService";

const BASE_URL = (
  process.env.REACT_APP_BACKEND_URL
).replace(/\/$/, "");
const RUTA = `${BASE_URL}/api/v1/roles`;

/* Helpers consistentes con otros services */
const toJson = (res) => res.json().catch(() => ({}));
const ensureOk = async (res, data) => {
  if (!res.ok) {
    // intenta mostrar mensaje del backend si viene
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};

/** GET /api/v1/roles */
export async function listRoles() {
  const res = await fetch(RUTA, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  await ensureOk(res, data);
  // algunos backends devuelven {status, message, data: []}
  return Array.isArray(data) ? data : data?.data ?? [];
}

/** GET /api/v1/roles/filter?nombre=... */
export async function getRolByNombre(nombre) {
  const url = `${RUTA}/filter?nombre=${encodeURIComponent(nombre)}`;
  const res = await fetch(url, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  if (res.status === 404) return null;
  const data = await toJson(res);
  await ensureOk(res, data);
  return data?.data ?? null;
}

/** POST /api/v1/roles */
export async function createRol(payload) {
  const res = await fetch(RUTA, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  const data = await toJson(res);
  await ensureOk(res, data);
  return data?.data ?? data;
}

/** PUT /api/v1/roles/:id */
export async function updateRol(id, payload) {
  const res = await fetch(`${RUTA}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  const data = await toJson(res);
  await ensureOk(res, data);
  return data?.data ?? data;
}

/** DELETE /api/v1/roles/:id */
export async function deleteRol(id) {
  const res = await fetch(`${RUTA}/${id}`, {
    method: "DELETE",
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  await ensureOk(res, data);
  return true;
}
